import { render } from "./TeamLeadPlanningComponent.vue?vue&type=template&id=5c068bfa&scoped=true"
import script from "./TeamLeadPlanningComponent.vue?vue&type=script&lang=js"
export * from "./TeamLeadPlanningComponent.vue?vue&type=script&lang=js"

import "./TeamLeadPlanningComponent.vue?vue&type=style&index=0&id=5c068bfa&scoped=true&lang=scss"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c068bfa"]])

export default __exports__